import { render, staticRenderFns } from "./danger.vue?vue&type=template&id=3fa2ac56&scoped=true&"
import script from "./danger.vue?vue&type=script&lang=js&"
export * from "./danger.vue?vue&type=script&lang=js&"
import style0 from "./danger.vue?vue&type=style&index=0&id=3fa2ac56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2ac56",
  null
  
)

export default component.exports